import Vue from 'vue';
import store from '@/store';
const permissionDirective = {}
const toggleLoading = (el, data) => {
  let missionList = store.state['permissions/permissions'].missions
  if (data) {
    let temp
    if (Array.isArray(data)) {
      temp = data.find(res => {
        return missionList.find(item => item.permission_name === res)
      })
    } else {
      temp = missionList.find(res => res.permission_name === data)
    }
    if (!temp) {
      el.style.display = 'none'
    }
  }
}
permissionDirective.install = Vue => {
  Vue.directive('permission', {
    bind: function (el, binding, vnode) {
      toggleLoading(el, binding.value)
    },
    update: function (el, binding) {
      toggleLoading(el, binding.value)
    },

    unbind: function (el, binding) {
      toggleLoading(el, binding.value)
    }
  });
}
Vue.prototype.$permission = (data) => {
  let missionList = store.state['permissions/permissions'].missions
  let temp
  if (Array.isArray(data)) {
    temp = data.find(res => {
      return missionList.find(item => item.permission_name === res)
    })
  } else {
    temp = missionList.find(res => res.permission_name === data)
  }
  return Boolean(temp)
}
export default permissionDirective
